import { createStore } from "owa-satcheljs";
import type { ProtectYourAccountDialogState } from "./schema/ProtectYourAccountDialogState";

export const getProtectYourAccountDialogStore: () => ProtectYourAccountDialogState = createStore<ProtectYourAccountDialogState>("protectYourAccountDialogStore", {
    status: "Unseen",
    mailboxInfo: undefined,
    campaign: undefined,
});
